import { cacheResource, bindResource, addOnInvalidateHandler, invalidateResource } from "kea-resource";
import { Tarifa } from "../simple";
import { MatrizTarifa, } from "./matriztarifa";
import { ConfigSistema } from "./configsistema";
import { Cliente } from "./cliente";
import { Subject } from "rxjs";
import { Observable } from "rxjs/Observable";

const sub = new Subject<void>();
//Invalidamos la documentación cuando cambie la tarifa
addOnInvalidateHandler(MatrizTarifa, () => sub.next());
addOnInvalidateHandler(Tarifa, () => sub.next());
addOnInvalidateHandler(ConfigSistema, () => sub.next());
addOnInvalidateHandler(Cliente, () => sub.next());

/**Observable que lanza un evento cada vez que existe un posible cambio que afecte a los calculos de las tarifas de la guia */
export const onCambioTarifa: Observable<void> = sub;


// WEBPACK FOOTER //
// ./app/resources/items/tarifaupdate.ts